import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const BULLETINNOTES_URL = `${backendUrl}/api/bulletin/evaluation/notes/`;
const BULLETIN_EVALUATION_URL = `${backendUrl}/api/bulletin/`;
const BULLETIN_TRIMESTRIEL_URL = `${backendUrl}/api/trimestriel/`;
const BULLETIN_ANNUEL_URL = `${backendUrl}/api/annuel/`;

class BulletinnoteService {
	// Récupérer tous les bulletins
	async getBulletinEvaluation(
		salledeclasseId,
		eleveId,
		examenId,
		anneeScolaire
	) {
		try {
			const response = await axios.get(BULLETIN_EVALUATION_URL + 'filter/', {
				params: {
					salledeclasseId: salledeclasseId,
					eleveId: eleveId,
					examenId: examenId,
					anneeScolaire: anneeScolaire
				}
			});
			return response.data; // Le backend renvoie déjà les données filtrées
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	async getBulletinTrimestriel(
		salledeclasseId,
		eleveId,
		trimestreId,
		anneeScolaire
	) {
		try {
			const response = await axios.get(BULLETIN_TRIMESTRIEL_URL + 'filter/', {
				params: {
					salledeclasseId: salledeclasseId,
					eleveId: eleveId,
					trimestreId: trimestreId,
					anneeScolaire: anneeScolaire
				}
			});
			return response.data; // Le backend renvoie déjà les données filtrées
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	async getBulletinAnnuel(salledeclasseId, eleveId, anneeScolaire) {
		try {
			const response = await axios.get(BULLETIN_ANNUEL_URL + 'filter/', {
				params: {
					salledeclasseId: salledeclasseId,
					eleveId: eleveId,
					anneeScolaire: anneeScolaire
				}
			});
			return response.data; // Le backend renvoie déjà les données filtrées
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	// Créer un bulletin avec ses notes associées
	async createBulletinnoteWithNotes(data) {
		try {
			const response = await axios.post(BULLETINNOTES_URL, data);
			return response.data;
		} catch (error) {
			console.error(
				'Erreur lors de la création du bulletin avec les notes',
				error
			);
			throw error;
		}
	}

	async updateBulletinWithNotes(id, data) {
		try {
			const response = await axios.put(`${BULLETINNOTES_URL}${id}/`, data);
			return response.data;
		} catch (error) {
			console.error(
				'Erreur lors de la mise à jour du bulletin avec les notes',
				error
			);
			throw error;
		}
	}
}

export default new BulletinnoteService();
